import { Button, Col, Row } from "antd";
import React, { createContext, useState } from "react";
import { useUserRoles } from "../../../_core/hooks/useUserRoles";
import { ProjectDialog } from "../ProjectDialog";
import {
  Project as ProjectInterface,
  ProjectFormInputData,
  User,
} from "../types";
import useUsers from "../useUsers";
import { ProjectsTable } from "./ProjectsTable";
import { SearchBar } from "./SearchBar";
import { useProjects } from "./useProjects";

export interface ProjectsContextInterface {
  projects: ProjectInterface[];
  isLoading: boolean;
  filteredProjects: ProjectInterface[];
  onSearch(input: string): void;
  createProject(values: ProjectFormInputData): Promise<any>;
  updateProject(projectId: string, values: ProjectFormInputData): Promise<any>;
  deleteProject(projectId: string): Promise<any>;
  users: User[];
  isUsersLoading: boolean;
  getUsersTechnologies: ReturnType<typeof useUsers>["getUsersTechnologies"];
}

//@ts-ignore
export const ProjectsContext = createContext<ProjectsContextInterface>();

export const AllProjects = () => {
  const [addProjectDialog, setAddProjectDialog] = useState(false);
  const { isAdmin } = useUserRoles();
  const projectsRet = useProjects();
  const usersRet = useUsers();

  return (
    <ProjectsContext.Provider value={{ ...projectsRet, ...usersRet }}>
      <div>
        <Row justify="space-between" style={{ marginBottom: 10 }}>
          <Col flex="1" style={{ marginRight: 5 }}>
            <SearchBar />
          </Col>
          {isAdmin() && (
            <Col>
              <Button
                type="primary"
                style={{ borderRadius: 5 }}
                onClick={() => setAddProjectDialog(true)}
              >
                Add new project
              </Button>
            </Col>
          )}
        </Row>
        <ProjectsTable />
        <ProjectDialog
          isVisible={addProjectDialog}
          setIsVisible={setAddProjectDialog}
          createProject={projectsRet.createProject}
          isLoading={projectsRet.isLoading}
          users={usersRet.users}
        />
      </div>
    </ProjectsContext.Provider>
  );
};
